import React, { createContext, useContext, useState, useRef } from 'react';

const ChatContext = createContext();

export const ChatProvider = ({ children }) => {
  const [chatActive, setChatActive] = useState(false);
  const [chatVisible, setChatVisible] = useState(false);
  const [responseTexts, setResponseTexts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [userMessage, setUserMessage] = useState('');

  const audioRef = useRef(null);
  const dataChannelRef = useRef(null);
  const peerConnectionRef = useRef(null);
  const messagesEndRef = useRef(null);

  const toggleChatVisibility = () => {
    setChatVisible(!chatVisible);
  };

  const toggleChatActive = () => {
    setChatActive(!chatActive);
  };

  const clearChat = () => {
    setResponseTexts([]);
  };

  const value = {
    chatActive,
    setChatActive,
    chatVisible,
    setChatVisible,
    toggleChatVisibility,
    toggleChatActive,
    responseTexts,
    setResponseTexts,
    loading,
    setLoading,
    userMessage,
    setUserMessage,
    audioRef,
    dataChannelRef,
    peerConnectionRef,
    messagesEndRef,
    clearChat,
  };

  return (
    <ChatContext.Provider value={value}>
      {children}
    </ChatContext.Provider>
  );
};

export const useChat = () => {
  const context = useContext(ChatContext);
  if (!context) {
    throw new Error('useChat must be used within a ChatProvider');
  }
  return context;
}; 